import React, {Component} from "react";
import {dateEqualsToday, dateEqualsYesterday, dateEqualsTomorrow, formatDateString, getHours, getAMorPM} from "../../shared/dateFormatter";
import ContentPanelTextReplace from "../ContentPanelTextReplace/ContentPanelTextReplace";
import ContentPanel from "../ContentPanel/ContentPanel";
import {requestScanStatusData} from "../../actions/scanStatusDataActions";
import connect from "react-redux/es/connect/connect";
import withRouter from "react-router/es/withRouter";
import Skeleton from "../Skeleton/Skeleton";
import {NavLink} from "react-router-dom";

const mapStateToProps = (state) => {
    return {
        scanStatusData: state.scanStatusData
    }
};

const mapDispatchToProps = dispatch => ({
    getScanStatuses: (request) => dispatch(requestScanStatusData(request))
});

class TrackingDetailsPieceInfo extends Component {
    componentDidMount() {
        this.props.getScanStatuses({
            awbPrefix: this.props.awbPrefix,
            airWaybillNumber: this.props.airWaybillNumber,
            isoCreateDate: this.props.isoCreateDate
        })
    }

    render() {
        let retVal;

        if (this.props.scanStatusData.isFetching) {
            retVal = <div className="piece-detail">Loading...</div>;
        } else if (this.props.scanStatusData.noResults || this.props.scanStatusData.error || this.props.scanStatusData.scanStatuses.length === 0) {
            retVal = <ContentPanel
                    skeleton={<Skeleton type="MAIN_PANEL"/>}
                    errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                    templateUrl={"./content/ship/page-components/text-block/scans-unavailable.html"}
            />;
        } else {
            let tblRows = "";
            this.props.scanStatusData.scanStatuses.forEach((scanStatus, index) => {
                let flightNumber;
                this.props.legs.forEach(leg => {
                    if (dateEqualsToday(scanStatus.scanTime) ||
                            dateEqualsTomorrow(scanStatus.scanTime) ||
                            dateEqualsYesterday(scanStatus.scanTime)) {
                        let scheduledDepart = formatDateString(scanStatus.scanTime, "YYYY-MM-DD");
                        let swaUrl = "https://www.southwest.com/air/flight-status/path?departureDate=" + scheduledDepart + "&flightNumber=" + scanStatus.flightNumber;
                        flightNumber = "<a href=\"" + swaUrl + "\" target=\"_blank\">" + scanStatus.flightNumber + "</a>";
                    } else {
                        flightNumber = scanStatus.flightNumber;
                    }
                });

                tblRows = tblRows + "<div class=\"divTableRow\"><div class=\"divTableCell\">" + getHours(scanStatus.scanTime) + " " + getAMorPM(scanStatus.scanTime) + "</div>" +
                        "<div class=\"divTableCell\">" + scanStatus.scanType + "</div>" +
                        "<div class=\"divTableCell\">" + scanStatus.scanStation + "</div>" +
                        "<div class=\"divTableCell\">" + flightNumber + "</div>" +
                        "<div class=\"divTableCell\">" + scanStatus.scanCount + "</div></div>";
            });

            let textReplaceMap = {"SCAN_INFO": tblRows};
            retVal = <div>{<ContentPanelTextReplace
                    skeleton={<Skeleton type="MAIN_PANEL"/>}
                    errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                    templateUrl={"./content/ship/page-components/text-block/scan-info.html"}
                    textReplaceMap={textReplaceMap}
            />}<NavLink to={{
                pathname: '/tracking-details/scan-details',
                search: `trackingId=${this.props.awbPrefix}-${this.props.airWaybillNumber}&createDate=${this.props.isoCreateDate}`
            }}> scan details </NavLink></div>
        }
        return retVal;
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrackingDetailsPieceInfo));



// WEBPACK FOOTER //
// ./src/components/TrackingDetailsPieceInfo/TrackingDetailsPieceInfo.js